import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-employee-kpi-details',
  templateUrl: './employee-kpi-details.component.html',
  styleUrls: ['./employee-kpi-details.component.css']
})
export class EmployeeKpiDetailsComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private apiService:ServiceService
  ) { }

  OutputData:any
  Usertype:string =''
  year_month:string = ''
  
  ngOnInit(): void {
    var date = new Date()
    var getmonth = (date.getMonth() + 1).toString().padStart(2, '0');
    var getYear = date.getFullYear()
    this.year_month = `${getYear}-${getmonth}`
    this.responseChange()
  }
  responseChange(){
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      if (params['id']) {
        const _id = params['id'];
        const UserType = params['userType']
        this.Usertype = UserType
        if(UserType.toUpperCase() == 'SALES_PROMOTER'){
          this.getsaleDetails(_id)
        }else{
        this.getDetails(_id)
        }
      }
    });
  }

  getDetails(_id:string){
    var ParamsValue = 'month_filter=' + this.year_month +'&employee_id=' + _id
    this.apiService.viewEmployeeKpi(ParamsValue).subscribe({
      next : (response) =>  {
        console.log(response);
        if(response.sucess == 'true'){
          this.OutputData = response.data[0]
        }else{
          alert("Response Error")
        }
        
      }, error : (err) => {
        alert("Server Error")
      }, 
    })
  }
  getsaleDetails(_id:string){
    var ParamsValue = 'month_filter=' + this.year_month +'&employee_id=' + _id
    this.apiService.viewKpiSalespromoter(ParamsValue).subscribe({
      next : (response) =>  {
        console.log(response);
        if(response.sucess == 'true'){
          this.OutputData = response.data[0]
        }else{
          alert("Response Error")
        }
        
      }, error : (err) => {
        alert("Server Error")
      }, 
    })
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);

    // Extract date components using UTC methods
    const day = date.getUTCDate();
    const month = date.toLocaleString('default', { month: 'short', timeZone: 'UTC' });
    const year = date.getUTCFullYear();
    const weekday = date.toLocaleString('default', { weekday: 'long', timeZone: 'UTC' });

    // Format as "dd MMM yyyy, EEEE"
    return `${this.padZero(day)} ${month} ${year}, ${weekday}`;
  }

  // Helper function to pad single-digit days with a leading zero
  private padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

}
